<script lang="ts">
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'PanelFooter',
    setup() {}
  })
</script>

<template>
  <div>footer</div>
</template>
